import React from "react"
import ImageUpload from "components/ReactHookForm/ImageUpload"
import ImageUploadComponent from "components/ImageUploadComponent"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import extendFormValuesWithImages from "utilities/extendFormValuesWithImages"
import type { DioboxEvent } from "sharedTypes"

const KioskBackgroundImageUploadComponent = (
  props: React.ComponentProps<typeof ImageUploadComponent>,
) => (
  <ImageUploadComponent {...props} uploadButtonText="Upload Background Image" />
)

type Props = {
  isOpen: boolean
  onClose: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
}

const KioskBackgroundModal = ({
  isOpen,
  onClose,
  event,
  updateEvent,
}: Props) => {
  if (!isOpen) {
    return null
  }

  return (
    <ModalForm
      title="Background Image"
      size="xl"
      onClose={onClose}
      initialValues={{
        kioskBackgroundImageUrl: event.kioskBackgroundImageUrl ?? undefined,
        ...extendFormValuesWithImages({}, ["kioskBackgroundImage"]),
      }}
      onSubmit={async (v) => {
        await updateEvent({
          kioskBackgroundImage: v.kioskBackgroundImage,
          kioskBackgroundImageUrl: v.kioskBackgroundImageUrl,
        })
        onClose()
      }}
      disableSubmitWhenNotDirty
    >
      {({ control }) => (
        <ImageUpload
          name="kioskBackgroundImage"
          control={control}
          description="Customize Kiosk Mode with a full-screen background image displayed across all screens. For best results across different device sizes, use a high-resolution image without any text."
          imageWidth="auto"
          imageHeight="auto"
          imageMaxWidth={32}
          imageMaxHeight={32}
          imageFit="contain"
          imageUrl={event.kioskBackgroundImageUrl || ""}
          Component={KioskBackgroundImageUploadComponent}
          helperText="Supports PNG and JPG formats, up to 5 MB."
          vertical
          labelSize="lg"
          labelWeight="semibold"
        />
      )}
    </ModalForm>
  )
}

export default KioskBackgroundModal
